const appendParam = (params, key, value) => {
  if (value === undefined || value === null) return;

  if (Array.isArray(value)) {
    value.forEach((item) => appendParam(params, `${key}[]`, item));
    return;
  }

  if (typeof value === "object") {
    Object.keys(value).forEach((childKey) => {
      appendParam(params, `${key}[${childKey}]`, value[childKey]);
    });
    return;
  }

  params.append(key, value);
};

export const buildQueryString = (data = {}) => {
  const params = new URLSearchParams();

  Object.keys(data).forEach((key) => {
    appendParam(params, key, data[key]);
  });

  return params.toString();
};
